import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { MenuButton } from "@szhsin/react-menu"
import { formSubmissionSlug as formSubmissionSlugSelector } from "reduxSlices/formSubmissionSlice"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import * as API from "services/api"
import { setResolution, removeResolution, resolutionText as getResolutionText } from "reduxSlices/formSubmissionResolutionSlice"
import Modal, { ModalHeader, DEFAULT_MODAL_STYLE } from "shared/Modal"
import { errorToast, successToast } from "components/shared/toast"
import { useModal } from "hooks"
import ResolutionForm from "./ResolutionForm"

const DELETE_FAILURE_MESSAGE = "Something went wrong. Unable to delete resolution."
const CONFIRM_DELETE_MESSAGE = "Are you sure you want to delete the resolution?"
const MODAL_STYLE = {
  content: {
    ...DEFAULT_MODAL_STYLE.content,
    overflowX: "hidden",
  },
}

const ResolutionMenu = () => {
  const dispatch = useDispatch()

  const formSubmissionSlug = useSelector(formSubmissionSlugSelector)
  const resolutionText = useSelector(getResolutionText)

  const { modalIsOpen, openModal, closeModal } = useModal()

  const deleteResolution = async () => {
    if (window.confirm(CONFIRM_DELETE_MESSAGE)) {
      const response = await API.deleteFormSubmissionResolution({ formSubmissionSlug })

      if (response.ok) {
        dispatch(removeResolution())
        successToast("Resolution deleted.")
      } else {
        errorToast(DELETE_FAILURE_MESSAGE)
      }
    }
  }

  const updateResolution = async (resolutionData) => {
    const { text } = resolutionData
    const response = await API.updateFormSubmissionResolution({ text, formSubmissionSlug })

    if (response.ok) {
      dispatch(setResolution({ resolution: { text } }))
      successToast("Resolution updated.")
      closeModal()
    } else {
      errorToast("Something went wrong. Unable to edit resolution.")
    }
  }

  return (
    <>
      <ExpandMenu
        expandMenuComponent={(
          <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
            <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
          </MenuButton>
        )}
      >
        <ExpandMenuItem onClick={openModal}>
          Edit
        </ExpandMenuItem>
        <ExpandMenuItem onClick={deleteResolution}>
          Delete
        </ExpandMenuItem>
      </ExpandMenu>
      <Modal isOpen={modalIsOpen} style={MODAL_STYLE}>
        <ModalHeader closeModal={closeModal} heading="Edit Resolution" />
        <ResolutionForm onCancel={closeModal} onSubmit={updateResolution} initialValues={{ text: resolutionText }} />
      </Modal>
    </>
  )
}

export default ResolutionMenu
